import React from 'react';
import { Link } from 'react-router-dom';
import PaintTitle from './PaintTitle';

export default function SnapCubeFeature({ project, id = 'featured', focusQuery = '' }) {
    if (!project) return null;
    return <section className="work-feature" id={id}>
        <div className="work-heading">
            <span className="section-label">{id === 'featured' ? '01 / Featured build' : '02 / Engineering and AR'}</span>
            <PaintTitle>SnapCube</PaintTitle>
        </div>
        <div className="work-lead">
            <iframe className="snapcube-demo" src={project.demoVideo} title="SnapCube Rubik's Cube guide on Snapchat Spectacles" loading="lazy" allow="fullscreen; picture-in-picture" allowFullScreen />
            <div className="work-intro">
                <h3>A physical puzzle, an AR guide.</h3>
                <p>I built a Rubik's Cube guide for Snapchat Spectacles. Scan the physical cube one face at a time, then follow an animated virtual cube through the solution.</p>
                <p>The project brings together computer vision, a custom ML model hosted on AWS, and real-time AR rendering.</p>
                <p className="work-meta">{project.date}</p>
                <div className="work-links">
                    <Link to={`/project/${project.id}${focusQuery}`}>Explore SnapCube</Link>
                    <a href={project.demoVideo.replace('/embed/', '/watch?v=')} target="_blank" rel="noreferrer">Watch demo on YouTube</a>
                </div>
            </div>
        </div>
    </section>;
}
